import Vue from 'vue'

const COMMON = new Vue();

export default COMMON


// WEBPACK FOOTER //
// ./src/components/common.js